import request from "@/service";

//列表
export function lecturerTypeTree() {
  return request({
    url: `/resource/sys/lecturerType/tree`,
    method: "get"
  });
}

//详情
export function lecturerTypeInfo(uuid) {
  return request({
    url: `/resource/sys/lecturerType/info/${uuid}`,
    method: "get"
  });
}

//新增
export function lecturerTypeSave(data) {
  return request({
    url: `/resource/sys/lecturerType/save`,
    method: "post",
    data
  });
}

//编辑
export function lecturerTypeUpdate(data) {
  return request({
    url: `/resource/sys/lecturerType/update`,
    method: "put",
    data
  });
}

//删除
export function lecturerTypeDelete(data) {
  return request({
    url: `/resource/sys/lecturerType/delete`,
    method: "delete",
    data
  });
}
